var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pattern-background',[_c('div',{staticClass:"login-wrapper"},[_c('login',{attrs:{"showLogo":"true","showNote":"true","message":"🙋‍♀️ Please log in to participate in this Retro with your team."}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }